module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-tabs",
    attrs: {
      "id": "tabs"
    }
  }, _vm._l((_vm.routes), function(route) {
    return _c('transition-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (route.routeKey === _vm.currentRoute),
        expression: "route.routeKey === currentRoute"
      }],
      key: route.routeKey,
      staticClass: "app-tabs__inner",
      attrs: {
        "name": "tabs-transition",
        "tag": "div"
      }
    }, _vm._l((route.appStateHistory), function(tab) {
      return _c('button', {
        key: tab.stackId,
        class: ['app-tabs__item', {
          'active': _vm.isActive(tab)
        }, {
          'can-delete': _vm.canDeleteTabs
        }],
        attrs: {
          "id": tab.stackId
        },
        on: {
          "click": function () { return _vm.onSwitch(tab); }
        }
      }, [_c('div', {
        staticClass: "app-tabs__item__inner"
      }, [_c('span', [_vm._v(_vm._s(_vm.visibleStackItem(tab).title))]), _vm._v(" "), _c('svg', {
        staticClass: "app-tabs__close",
        attrs: {
          "version": "1.1",
          "xmlns": "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "x": "0px",
          "y": "0px",
          "viewBox": "0 0 24 24",
          "enable-background": "new 0 0 24 24",
          "xml:space": "preserve"
        },
        on: {
          "click": function () { return _vm.closeTab(tab); }
        }
      }, [_c('path', {
        attrs: {
          "d": "M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284\n                                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414\n                                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293\n                                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"
        }
      })])])])
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a13d327","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/AppTabs/index.vue
// module id = 428
// module chunks = 1